export const COLOR = {
  BACKCOLOR_ITEM_NAME: "#eaf4fc",
  BACKCOLOR_HIGHLIGHTED_ITEM_NAME: "#ffdab9",
};
